import { render, staticRenderFns } from "./book-comments.vue?vue&type=template&id=f8076df8&scoped=true"
import script from "./book-comments.vue?vue&type=script&lang=js"
export * from "./book-comments.vue?vue&type=script&lang=js"
import style0 from "./book-comments.vue?vue&type=style&index=0&id=f8076df8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8076df8",
  null
  
)

export default component.exports